import { useMemo } from 'react';
import {
  useExportHistoryListNumberOfEmployeeQuery,
  useExportProgressNumberOfEmployeeSubscription,
} from '@/common/graphql';
import type { ExportHistoryKind, UseExportHistoryResult } from './types';
import { toExportHistoryRow } from './types';

/** Query + Subscription + row-mapping for `kind: 'numberOfEmployee'`. Always called - internally no-ops via `skip` when inactive. */
export function useExportHistoryNumberOfEmployee(kind: ExportHistoryKind, onlyMyTask: boolean): UseExportHistoryResult {
  const skip = kind !== 'numberOfEmployee';

  const { data, loading, error, refetch } = useExportHistoryListNumberOfEmployeeQuery({
    skip,
    fetchPolicy: 'cache-and-network',
    variables: { onlyMyTask },
  });
  const history = useMemo(() => (data?.exportHistoryList ?? []).map(toExportHistoryRow), [data?.exportHistoryList]);

  const { data: progressData } = useExportProgressNumberOfEmployeeSubscription({ skip });
  const progress = useMemo(() => progressData?.exportProgress ?? [], [progressData?.exportProgress]);

  return { error, history, isActive: !skip, loading, progress, refetch };
}
